import { useEffect, useMemo, useRef, useState } from "react";
import ModalDefault from "../../modalDefault";
import {
  ActionIcon,
  Group,
  MultiSelect,
  TextInput,
  Switch,
  Badge,
  Button,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { DataTable } from "mantine-datatable";
import moment from "moment/moment";
import { toast } from "react-hot-toast";
import {
  ApiActivarDesactivarDefinitivoUsuario,
  ApiActivarDesactivarUsuario,
  ApiGetAllUsers,
  ApiGetTotalAllUsers,
  UpdatePassword,
} from "../../../api/usuarios";
import Agrupar from "./AgruparUsuarios";
import TotalRecordsToggleCard from "./TotalRecors";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import * as XLSX from "xlsx";

dayjs.extend(utc);
dayjs.extend(timezone);

const BATCH_SIZE = 15;

const TablaOpciones = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [showModalPassword, setShowModalPassword] = useState(false);
  const [allUsers, setAllUsers] = useState([]); // Nuevo estado para todos los usuarios
  const [allData, setAllData] = useState([]); // Nuevo estado para todos los usuarios
  const [users, setUsers] = useState([]); // Estado para usuarios filtrados
  const [cargos, setCargos] = useState([]);
  const [fetching, setfetching] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [password, setPassword] = useState("");

  //estado de filtros
  const [action, setAction] = useState("inactivar");

  //scroll infinito
  const [loadingMore, setLoadingMore] = useState(false);
  const [loadedRecords, setLoadedRecords] = useState(BATCH_SIZE);
  const scrollViewportRef = useRef(null);

  //filtros
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCargos, setSelectedCargos] = useState([]);
  const [birthdayRange, setBirthdayRange] = useState([null, null]);
  const [onlyActive, setOnlyActive] = useState(false);
  const [onlyWithCode, setOnlyWithCode] = useState(false);

  const [showModalTickets, setShowModalTickets] = useState(false);
  const [modalTicketsData, setModalTicketsData] = useState([]);
  const [onlyBirthdayTickets, setOnlyBirthdayTickets] = useState(false);

  //ordenamiento
  const [isInit, setIsInit] = useState(false);
  const [sortStatus, setSortStatus] = useState({
    columnAccessor: "",
    direction: "asc",
  });

  const cargoOptions = useMemo(
    () =>
      Array.from(
        new Set(
          cargos
            .map((c) => (c.pre_cargo ?? "").trim())
            .filter((v) => v.length > 0)
        )
      )
        .sort((a, b) => a.localeCompare(b, "es"))
        .map((v) => ({ value: v, label: v })),
    [cargos]
  );

  const columns = [
    {
      accessor: "usuario",
      title: "Cedula",
      textAlignment: "center",
    },
    {
      accessor: "code",
      title: "Codigo",
      textAlignment: "center",
    },
    {
      accessor: "correo",
      title: "Correo",
      textAlignment: "center",
    },
    {
      accessor: "nombres",
      title: "Nombre",
      textAlignment: "center",

      sortable: true,
    },
    {
      accessor: "apellidos",
      title: "Apellido",
      textAlignment: "center",

      sortable: true,
    },
    {
      accessor: "fecha_naci",
      title: "Cumpleaños",
      textAlignment: "center",
    },
    {
      accessor: "pre_cargos.pre_cargo",
      title: "Cargo",
      textAlignment: "center",
    },
    {
      accessor: "pre_areas.pre_area",
      title: "Área",
      textAlignment: "center",
    },
    {
      accessor: "pre_tipos_usuarios.tipo",
      title: "Tipo",
      textAlignment: "center",
    },
    {
      accessor: "acciones",
      title: "Acciones",
      textAlignment: "center",
      render: (record) => opciones(record),
    },
  ];

  const init = async () => {
    let pageSize = 200;
    setfetching(true);
    let auxdata = [];
    const res = await ApiGetTotalAllUsers();
    if (res.sms === "ok") {
      const totalPages = Math.ceil(res.data / pageSize);
      for (let i = 1; i <= totalPages; i++) {
        const { data, sms } = await ApiGetAllUsers({
          page: i,
          pageSize: pageSize,
        });
        if (sms === "ok") {
          console.log(data, i);
          auxdata = [...auxdata, ...data];
          /* for (let index = 0; index < data.length; index++) {
          } */
        }
      }
    }
    // const filterUsers = auxdata.filter((user) => user.estado !== false);
    setAllData(auxdata);
    // setAllUsers(auxdata);
    // setUsers(auxdata);
    setfetching(false);
    let cargosMap = new Map();
    auxdata.forEach((user) => {
      if (user.pre_cargos) {
        cargosMap.set(user.pre_cargos.pre_cargo_id, user.pre_cargos);
      }
    });
    setCargos([...cargosMap.values()]);
    setIsInit(true);
  };

  useEffect(() => {
    setAllUsers(allData);
    setUsers(allData);
  }, [allData]);

  const parseDOBToMMDD = (fecha) => {
    if (!fecha || typeof fecha !== "string") return null;
    const f = fecha.trim();

    // Formatos soportados:
    // 1) DD/MM[/YYYY]
    if (f.includes("/")) {
      const p = f.split("/").map((x) => x.trim());
      if (p.length >= 2) {
        const d = Number(p[0]);
        const m = Number(p[1]);
        if (d > 0 && m > 0) return m * 100 + d;
      }
      return null;
    }

    // 2) YYYY-MM-DD
    if (f.includes("-")) {
      const p = f.split("-").map((x) => x.trim());
      if (p.length >= 3 && p[0].length === 4) {
        const m = Number(p[1]);
        const d = Number(p[2]);
        if (d > 0 && m > 0) return m * 100 + d;
        return null;
      }
      // 3) DD-MM[-YYYY]
      if (p.length >= 2) {
        const d = Number(p[0]);
        const m = Number(p[1]);
        if (d > 0 && m > 0) return m * 100 + d;
      }
      return null;
    }

    return null;
  };

  const getMMDD = (dateObj) => {
    if (!(dateObj instanceof Date)) return null;
    const m = dateObj.getMonth() + 1;
    const d = dateObj.getDate();
    return m * 100 + d;
  };

  const isBirthdayInRange = (fecha_naci, start, end) => {
    const mmddBirth = parseDOBToMMDD(fecha_naci);
    if (!mmddBirth) return false;

    const mmddStart = getMMDD(start);
    const mmddEnd = getMMDD(end);
    if (!mmddStart || !mmddEnd) return false;

    if (mmddStart <= mmddEnd) {
      // Rango normal (mismo año)
      return mmddBirth >= mmddStart && mmddBirth <= mmddEnd;
    }
    // Rango que cruza año (ej. 20-Dic → 10-Ene)
    return mmddBirth >= mmddStart || mmddBirth <= mmddEnd;
  };

  //logica para manejar el filtro
  useEffect(() => {
    const searchTermLower = searchTerm.toLowerCase();
    const selectedCargosSet = new Set(selectedCargos);
    const [start, end] = birthdayRange || [null, null];
    const hasBirthdayRange = !!start && !!end;

    const filteredUsers = allUsers.filter((user) => {
      const matchesSearch =
        user.usuario.toLowerCase().includes(searchTermLower) ||
        (user.code &&
          user.code.toString().toLowerCase().includes(searchTermLower)) ||
        user.nombres.toLowerCase().includes(searchTermLower) ||
        user.apellidos.toLowerCase().includes(searchTermLower) ||
        user.fecha_naci?.toLowerCase().includes(searchTermLower);

      const matchesActive = !onlyActive ? true : user.estado === true;
      const matchesCode = !onlyWithCode ? true : Boolean(user.code);

      const matchesCargo =
        selectedCargos.length === 0 ||
        selectedCargosSet.has(user.pre_cargos?.pre_cargo);

      const matchesBirthday = !hasBirthdayRange
        ? true
        : isBirthdayInRange(user.fecha_naci, start, end);

      return (
        matchesSearch &&
        matchesCargo &&
        matchesBirthday &&
        matchesActive &&
        matchesCode
      );
    });

    setUsers(filteredUsers);
  }, [
    allUsers,
    searchTerm,
    selectedCargos,
    birthdayRange,
    onlyActive,
    onlyWithCode,
  ]);

  //logica para manejar el ordenamiento
  useEffect(() => {
    if (!isInit) return;
    if (sortStatus.columnAccessor === "nombres") {
      const sortedRecords = [...allUsers].sort((a, b) => {
        const nombreA = a.nombres.toLowerCase();
        const nombreB = b.nombres.toLowerCase();
        return nombreA.localeCompare(nombreB);
      });

      if (sortStatus.direction === "desc") {
        setAllUsers(sortedRecords.reverse());
      } else {
        setAllUsers(sortedRecords);
      }
    }

    if (sortStatus.columnAccessor === "apellidos") {
      const sortedRecords = [...allUsers].sort((a, b) => {
        const apellidoA = a.apellidos.toLowerCase();
        const apellidoB = b.apellidos.toLowerCase();
        return apellidoA.localeCompare(apellidoB);
      });

      if (sortStatus.direction === "desc") {
        setAllUsers(sortedRecords.reverse());
      } else {
        setAllUsers(sortedRecords);
      }
    }
  }, [sortStatus]);

  useEffect(() => {
    setfetching(true);
    iniciar();
  }, [props.updateList]);

  const iniciar = async () => {
    init();
  };

  const handleFilters = (field, value) => {
    if (field === "" && value === "") {
      setAllUsers(allData);
      setUsers(allData);
      return;
    }
    setLoadingMore(true);
    setTimeout(() => {
      const getNestedValue = (obj, field) => {
        return field.split(".").reduce((acc, key) => acc?.[key], obj);
      };

      const filterUsers = allData.filter(
        (user) => getNestedValue(user, field) === value
      );

      setAllUsers(filterUsers);
      setUsers(filterUsers);
      setLoadingMore(false);
    }, 300);
  };

  // Carga más datos cuando se llega al final del scroll
  const loadMoreData = () => {
    if (loadedRecords < users.length) {
      setLoadingMore(true);
      setTimeout(() => {
        setLoadedRecords((prevLoaded) =>
          Math.min(prevLoaded + BATCH_SIZE, users.length)
        );
        setLoadingMore(false);
      }, 1000);
    }
  };

  // Asegúrate de no cargar más registros de los disponibles
  const visibleUsers = users.slice(0, Math.min(loadedRecords, users.length));

  const editUser = (row) => {
    const {
      nombres,
      apellidos,
      usuario,
      pre_rol_id,
      pre_cargo_id,
      pre_usuario_id,
      code,
      correo,
      fecha_naci,
      pre_tipo_usuario_id,
    } = row;
    const fechaMoment = moment(fecha_naci, "DD/MM/YYYY");
    const fecha_nacimiento = fechaMoment.isValid()
      ? fechaMoment.format("YYYY-MM-DD")
      : null;
    props.setType("editar");
    props.setState({
      ...props.state,
      nombres,
      apellidos,
      usuario,
      pre_rol_id,
      pre_cargo_id,
      pre_usuario_id,
      code,
      correo,
      fecha_naci: fecha_nacimiento ? fecha_nacimiento : "",
      pre_tipo_usuario_id,
    });
    props.setShowModalSave(true);
  };

  const onShowModal = (e, action) => {
    setAction(action);
    setShowModal(true);
    setSelectedUser(e);
  };

  const onClosedModal = () => {
    setShowModal(false);
    setSelectedUser(null);
  };

  const onShowModalPassword = (e) => {
    setSelectedUser(e);
    setShowModalPassword(true);
  };

  const onClosedModalPassword = () => {
    setShowModalPassword(false);
    setSelectedUser(null);
  };

  const onDelete = async () => {
    const { estado, pre_usuario_id } = selectedUser;
    let sms = "";
    let mensaje = "";
    if (action === "eliminar") {
      const { sms: status, mensaje: msg } =
        await ApiActivarDesactivarDefinitivoUsuario({
          pre_usuario_id,
        });
      sms = status;
      mensaje = msg;
    } else {
      const { sms: status, mensaje: msg } = await ApiActivarDesactivarUsuario({
        pre_usuario_id,
        pre_estado: !estado,
      });
      sms = status;
      mensaje = msg;
    }
    if (sms === "ok") {
      toast.success(mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid green",
          padding: "16px",
          color: "white",
          background: "green",
          borderColor: "white",
        },
        iconTheme: {
          primary: "green",
          secondary: "white",
        },
      });
      setSelectedUser(null);
      props.updateListFn();
    } else {
      toast.error(mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
    }
    onClosedModal();
  };

  const onUpdatePassword = async () => {
    const { pre_usuario_id } = selectedUser;
    const { sms, mensaje } = await UpdatePassword({
      pre_usuario_id,
      password,
    });
    if (sms === "ok") {
      toast.success(mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid green",
          padding: "16px",
          color: "white",
          background: "green",
          borderColor: "white",
        },
        iconTheme: {
          primary: "green",
          secondary: "white",
        },
      });
      setSelectedUser(null);
      props.updateListFn();
    } else {
      toast.error(mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
    }
    onClosedModalPassword();
  };

  const opciones = (row) => {
    return (
      <Group spacing={4} position="center" noWrap>
        <ActionIcon color="blue" onClick={() => onShowModalPassword(row)}>
          <i className="fas fa-key"></i>
        </ActionIcon>
        <ActionIcon
          color="blue"
          onClick={() => {
            editUser(row);
          }}
        >
          <i className="fas fa-file-pen"></i>
        </ActionIcon>
        <ActionIcon
          color={row.estado ? "red" : "green"}
          onClick={() => {
            onShowModal(row, "inactivar");
          }}
        >
          {row.estado ? (
            <i className="fa-solid fa-ban"></i>
          ) : (
            <i className="fa fa-check-circle"></i>
          )}
        </ActionIcon>
        <ActionIcon
          color={"red"}
          onClick={() => {
            onShowModal(row, "eliminar");
          }}
        >
          <i className="fas fa-trash"></i>
        </ActionIcon>
        {selectedUser && (
          <ModalDefault
            bandera={"confirmacion"}
            modal={showModal}
            size={"sm"}
            icontitulo={<null />}
            titulo={`Confirmación`}
            closeAction={onClosedModal}
          >
            <div className="py-4 justify-content-center text-align-center ">
              Realmente desea
              {action !== "eliminar" ? (
                <b>{selectedUser.estado ? " inactivar " : " activar "}</b>
              ) : (
                <b> eliminar definitivamente </b>
              )}
              el usuario{" "}
              <b>
                {selectedUser.nombres} {selectedUser.apellidos}
              </b>
            </div>
            <div className="d-flex justify-content-end flex-row align-self-start my-4">
              <button
                type=""
                onClick={onClosedModal}
                className="bg-btn-vet-danger sombra mx-1"
              >
                Cancelar
              </button>
              <button
                type=""
                onClick={onDelete}
                className="bg-btn-vet sombra mx-1"
              >
                <i className="fas fa-save">
                  {action !== "eliminar"
                    ? selectedUser.estado
                      ? "Inactivar"
                      : "Activar"
                    : "Eliminar"}
                </i>
              </button>
            </div>
          </ModalDefault>
        )}
      </Group>
    );
  };

  const getMMDDFromDayjs = (d) => Number(d.format("MMDD"));

  const onShowTicketsModal = () => {
    // users: arreglo filtrado actual
    const rows = users.flatMap((u) => {
      const tickets = Array.isArray(u.pre_tickets) ? u.pre_tickets : [];
      const mmddBirth = parseDOBToMMDD(u.fecha_naci); // ya definida en tu código

      return tickets.map((t) => {
        const dz = dayjs(t.create_at).tz("America/Guayaquil");
        const mmddTicket = getMMDDFromDayjs(dz);
        const isBD = Boolean(mmddBirth && mmddTicket === mmddBirth);

        return {
          usuario: `${u.nombres ?? ""} ${u.apellidos ?? ""}`.trim(),
          cedula: u.usuario ?? "",
          codigo: u.code ?? "",
          fechaTicketISO: dz.toISOString(), // para ordenar
          fechaTicketLabel: dz.format("YYYY-MM-DD HH:mm"),
          fechaNaci: u.fecha_naci ?? "",
          isBD,
        };
      });
    });

    rows.sort((a, b) => (a.fechaTicketISO < b.fechaTicketISO ? 1 : -1));

    setModalTicketsData(rows);
    setShowModalTickets(true);
  };

  // Handler para exportar lo que se ve (respeta "Solo cumpleañeros")
  const exportTicketsToExcel = () => {
    const visible = onlyBirthdayTickets
      ? modalTicketsData.filter((r) => r.isBD)
      : modalTicketsData;

    // Mapeo a filas “planas” con headers claros
    const data = visible.map((r) => ({
      Usuario: r.usuario,
      Cédula: r.cedula,
      Código: r.codigo,
      "Fecha ticket": r.fechaTicketLabel,
      "Fecha nacimiento": r.fechaNaci,
      Cumpleañero: r.isBD ? "Sí" : "No",
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    // Auto-width simple
    const colWidths = Object.keys(data[0] || {}).map((k) => ({
      wch:
        Math.max(k.length, ...data.map((row) => String(row[k] ?? "").length)) +
        2,
    }));
    ws["!cols"] = colWidths;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Tickets");
    const stamp = dayjs().format("YYYYMMDD_HHmmss");
    XLSX.writeFile(wb, `tickets_usuarios_${stamp}.xlsx`);
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <Agrupar data={allData} onFilters={handleFilters}></Agrupar>
      </div>
      <div className="col-md-6 mb-2">
        <TextInput
          placeholder="Buscar por cédula, código, nombre, apellido..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.currentTarget.value)}
          icon={<i className="fas fa-search" />}
          radius="md"
          size="md"
          styles={{
            root: { marginBottom: 15 },
            input: {
              transition: "all 0.3s ease",
              "&:focus": {
                transform: "scale(1.02)",
                borderColor: "#4DABF7",
                boxShadow: "0 0 0 2px rgba(77, 171, 247, 0.5)",
              },
            },
          }}
        />
      </div>
      <div className="col-md-6 mb-2">
        <MultiSelect
          data={cargoOptions}
          value={selectedCargos}
          onChange={setSelectedCargos}
          placeholder="Filtrar por cargo"
          clearable
          searchable
          // Filtro de texto (case-insensitive)
          filter={(query, _selected, item) =>
            item.label.toLowerCase().includes(query.toLowerCase())
          }
          // UX/estilo
          maxDropdownHeight={260}
          nothingFoundMessage="Sin resultados"
          comboboxProps={{ withinPortal: true }} // evita problemas de z-index
          style={{ marginBottom: 15 }}
        />
      </div>
      <div className="col-md-12 mb-3">
        <div className="d-flex gap-2 align-items-end">
          <div style={{ flex: 1 }}>
            <DatePickerInput
              type="range"
              placeholder="Selecciona un rango de fechas"
              value={birthdayRange}
              onChange={setBirthdayRange}
              clearable
            />
          </div>
          {birthdayRange?.[0] && birthdayRange?.[1] && (
            <button
              className="bg-btn-vet sombra"
              onClick={() => setBirthdayRange([null, null])}
              style={{ height: 40 }}
            >
              Limpiar rango
            </button>
          )}
        </div>
      </div>
      <div className="col-md-12 mb-3">
        <TotalRecordsToggleCard
          label="Usuarios"
          total={users.length}
          totalAll={allData.length}
          loading={fetching}
          searchTerm={searchTerm}
          selectedCargos={selectedCargos}
          birthdayRange={birthdayRange} // si ya lo tienes del filtro de cumpleaños
          onlyActive={onlyActive}
          onlyWithCode={onlyWithCode}
          onChangeFilters={(patch) => {
            if (typeof patch.onlyActive === "boolean")
              setOnlyActive(patch.onlyActive);
            if (typeof patch.onlyWithCode === "boolean")
              setOnlyWithCode(patch.onlyWithCode);
          }}
          onResetFilters={() => {
            setSearchTerm("");
            setSelectedCargos([]);
            setBirthdayRange([null, null]); // si usas el filtro de cumpleaños
            setOnlyActive(false);
            setOnlyWithCode(false);
            setAllUsers(allData);
            setUsers(allData);
          }}
          onRefresh={() => iniciar()}
          onShowTickets={onShowTicketsModal}
        />
      </div>
      <div className="col-md-12 mb-3">
        <DataTable
          borderRadius="md"
          className="bordecompleto bgfondo"
          highlightOnHover
          noRecordsText="No se encontraron datos"
          columns={columns}
          totalRecords={users.length}
          withColumnBorders
          records={visibleUsers}
          fetching={fetching || loadingMore}
          onScrollToBottom={loadMoreData}
          scrollViewportRef={scrollViewportRef}
          style={{ maxHeight: "500px", overflowY: "auto" }}
          sortStatus={sortStatus}
          onSortStatusChange={setSortStatus}
        />
      </div>
      <ModalDefault
        bandera={"confirmacion"}
        modal={showModalPassword}
        size={"sm"}
        titulo={`Nueva Contraseña`}
        closeAction={onClosedModalPassword}
      >
        <div className="row py-4 ">
          <div className="col-md-12">
            <label className="py-2 negrita">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={password}
              className="inputtext2 bordecompleto"
              placeholder="Digite el Password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
        </div>
        <div className="d-flex justify-content-end flex-row align-self-start my-4">
          <button
            type=""
            onClick={onClosedModalPassword}
            className="bg-btn-vet-danger sombra mx-1"
          >
            Cancelar
          </button>
          <button
            type=""
            onClick={onUpdatePassword}
            className="bg-btn-vet sombra mx-1"
          >
            <i className="fas fa-save"> Generar</i>
          </button>
        </div>
      </ModalDefault>
      {/* Modal: Mostrar tickets */}
      <ModalDefault
        bandera="confirmacion"
        modal={showModalTickets}
        size="lg"
        titulo="Tickets de usuarios (filtrados)"
        closeAction={() => setShowModalTickets(false)}
      >
        {/* Barra de controles del modal */}
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
          <Group spacing="md">
            <Switch
              size="sm"
              label="Solo cumpleañeros"
              checked={onlyBirthdayTickets}
              onChange={(e) => setOnlyBirthdayTickets(e.currentTarget.checked)}
            />
          </Group>

          {/* Totales */}
          <Group spacing="xs">
            <Badge color="indigo" variant="filled">
              Total:{" "}
              {
                (onlyBirthdayTickets
                  ? modalTicketsData.filter((r) => r.isBD)
                  : modalTicketsData
                ).length
              }
            </Badge>
            {onlyBirthdayTickets && (
              <Badge color="gray" variant="light">
                De {modalTicketsData.length}
              </Badge>
            )}
            <Button
              size="xs"
              variant="outline"
              onClick={exportTicketsToExcel}
              leftIcon={<i className="fa-regular fa-file-excel" />}
            >
              Exportar Excel
            </Button>
          </Group>
        </div>

        {/* Tabla responsive */}
        <div
          className="table-responsive"
          style={{
            maxHeight: "60vh",
            overflowY: "auto",
          }}
        >
          <table className="table table-striped table-bordered table-sm">
            <thead
              className="table-light"
              style={{ position: "sticky", top: 0, zIndex: 1 }}
            >
              <tr>
                <th>Usuario</th>
                <th className="d-none d-md-table-cell">Cédula</th>
                <th style={{ whiteSpace: "nowrap" }}>Fecha del ticket</th>
                <th
                  className="d-none d-sm-table-cell"
                  style={{ whiteSpace: "nowrap" }}
                >
                  Fecha de nacimiento
                </th>
                <th style={{ textAlign: "center" }}>🎂</th>
              </tr>
            </thead>
            <tbody>
              {(onlyBirthdayTickets
                ? modalTicketsData.filter((r) => r.isBD)
                : modalTicketsData
              ).length === 0 ? (
                <tr>
                  <td colSpan={5} className="text-center">
                    No hay tickets en el conjunto actual.
                  </td>
                </tr>
              ) : (
                (onlyBirthdayTickets
                  ? modalTicketsData.filter((r) => r.isBD)
                  : modalTicketsData
                ).map((r, idx) => (
                  <tr key={idx}>
                    <td>{r.usuario}</td>
                    <td className="d-none d-md-table-cell">{r.cedula}</td>
                    <td>{r.fechaTicketLabel}</td>
                    <td className="d-none d-sm-table-cell">{r.fechaNaci}</td>
                    <td style={{ textAlign: "center" }}>
                      {r.isBD ? "🎂" : ""}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="d-flex justify-content-end flex-row align-self-start mt-3">
          <button
            type=""
            onClick={() => setShowModalTickets(false)}
            className="bg-btn-vet sombra mx-1"
          >
            Cerrar
          </button>
        </div>
      </ModalDefault>
    </div>
  );
};

export default TablaOpciones;
